var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.CoreLayout,
    [
      !_setup.isMobile
        ? _c(_setup.CoreBread, { attrs: { items: _setup.breadcrumbs } })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex flex-column ga-8 ga-sm-10 mb-10",
          class: { container: !_setup.isMobile },
        },
        [
          _c(_setup.AnalysesHeroSection, {
            attrs: {
              "town-name-pred": _setup.context.town?.name_pred || "",
              "popular-analyses": _setup.popularTypes,
            },
          }),
          _vm._v(" "),
          _c(_setup.AnalysesCategoriesSection, {
            class: { container: _setup.isMobile },
            attrs: { categories: _setup.categories },
          }),
          _vm._v(" "),
          _c(_setup.AnalysesPopularSection, {
            class: { container: _setup.isMobile },
            attrs: { items: _setup.popularAnalyses },
          }),
          _vm._v(" "),
          _setup.context.is_analyses_appointment_available_in_town
            ? _c(_setup.AnalysesOnlineOrderSection, {
                attrs: { benefits: _setup.onlineOrderBenefits },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(_setup.LpuCardsSection),
          _vm._v(" "),
          _c(_setup.AnalysesMetaH1Subtitle, {
            class: { container: _setup.isMobile },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }